import React from "react";
import QuestionField from "../QuestionField";

const QuestionsForm = ({ questions, formData, errors, onInputChange }) => {
  return (
    <>
      {questions.map((question) => (
        <QuestionField
          key={question.questionId}
          question={question}
          value={formData[question.questionId] || ""}
          error={errors[question.questionId]}
          onChange={(value) => onInputChange(question.questionId, value)}
        />
      ))}
    </>
  );
};

export default QuestionsForm;